import { render, staticRenderFns } from "./companyverifydiff.vue?vue&type=template&id=1f486978&scoped=true"
import script from "./companyverifydiff.vue?vue&type=script&lang=js"
export * from "./companyverifydiff.vue?vue&type=script&lang=js"
import style0 from "./companyverifydiff.vue?vue&type=style&index=0&id=1f486978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f486978",
  null
  
)

export default component.exports